import { DataQueryKey, UseDataQueryKey } from '../../../../hooks/useDataQuery/dataQuery.types';
import { GetKitCombinationsFilters, GetKitCombinationsKeyParams } from './kitDetails.types';

export const getKitDetailsKey = (kitId: string): UseDataQueryKey => [
  DataQueryKey.KIT_DETAILS,
  kitId,
];

export const getKitCombinationsKey = ({
  kitId,
  filters,
  teamId,
}: GetKitCombinationsKeyParams): UseDataQueryKey => [
  DataQueryKey.KIT_COMBINATIONS,
  kitId,
  filters.catalogId,
  filters.isAdminSeller,
  ...(filters.orderIds ?? []),
  ...(filters.availabilities ?? []),
  teamId,
];

export const getKitCombinationsCountKey = (
  kitId: string,
  filters: GetKitCombinationsFilters,
): UseDataQueryKey => [
  DataQueryKey.KIT_COMBINATIONS_COUNT,
  kitId,
  filters.catalogId,
  filters.isAdminSeller,
  ...(filters.orderIds ?? []),
  ...(filters.availabilities ?? []),
];
